// extracted by mini-css-extract-plugin
export default {"button":"HeaderCartButton_button__-2-br","icon":"HeaderCartButton_icon__dHfSg","badge":"HeaderCartButton_badge__QAkfW","bump":"HeaderCartButton_bump__kxzOu"};